import React from "react";
import { useBulkConfig } from "../hooks/useBulkConfig";
import BulkResponseModal from "./BulkResponseModal";
import {
    useFetchAdminNotificationsData,
    useFetchNotificationBulkJobDetailsData,
    useSeenAdminNotificationMutation,
} from "../apis/notificationApis";
import { useProfileData } from "../apis/profileApis";
import toast from "react-hot-toast";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    bulkJobId: string;
    notification: any;
}

export const BulkResponseHandler: React.FC<Props> = ({
    isOpen,
    onClose,
    bulkJobId,
    notification,
}) => {
    const { data: bulkData } = useFetchNotificationBulkJobDetailsData(bulkJobId);
    const { mutate: statusMutate } = useSeenAdminNotificationMutation(notification?.id);
    const { refetch: profileFetch } = useProfileData();
    const { refetch: fetchNotifications } = useFetchAdminNotificationsData(1, 10, "");

    const { failColumns, allColumns, validationMessages } = useBulkConfig(
        notification?.message
    );

    const updateStatus = () => {
        statusMutate(undefined,
            {
                onSuccess: (res: any) => {
                    // console.log(res,'res')
                    // fetchNotifications();
                    // profileFetch();
                },
                onError: (error: any) => {
                    toast.error(`${error}`);
                },
            }
        );
    };

    if (!isOpen) return null;

    return (
        <BulkResponseModal
            onClose={() => {
                onClose();
                updateStatus();
                profileFetch();
                fetchNotifications();
            }}
            data={{
                successfulRows: bulkData?.successfulRows,
                failedRows: bulkData?.failedRows,
                errors: bulkData?.errors,
            }}
            config={{
                failKey: "errors",
                failColumns,
                allColumns,
                sheetName: "Failed Data",
                downloadFileName: "failed-rows",
                validationMessages,
            }}
        />
    );
};